import AddFarmer from "../../components/configuration/famer/AddFarmer"
const AddFarmerPage = () =>{
     
    return(

    
        <AddFarmer />
    )
}

export default AddFarmerPage;